export const SearchResult = ({ result, lat, lng, resultProps, id }) => {
  const handleResult = (e) => {
    // console.log(result);
    resultProps.setInput(result);
    if (!resultProps.home) {
      const list = resultProps.containerRef?.current?.querySelector(".results-list");
      if (list) list.classList.add("none");
    } else {
      resultProps.setResults([]);
    }
    resultProps.handeleClickFind(id, result, lat, lng);
  };
  return (
    <div
      className={resultProps.home ? "search-result" : "mini-search-result"}
      onClick={handleResult}
    >
      {result}
    </div>
  );
};